<template>
  <div class="rm-menu" @click="showSize = false">
    <div class="rm-menu-item first" v-if="getKnowledgeSigns.length && showSign">
      <el-switch :value="getKnowledgeSettings.isOpen" active-color="#FB7C33" inactive-color="#FFEDD1" @change="changeSetting('isOpen',$event)" style="margin: 10px 0 5px;" :disabled="disabled"></el-switch>
      <div class="txt">知识点</div>
    </div>
    <div class="rm-menu-item first">
      <button class="btn btn-flower  btn-tip btn-tip-left" @click="startFlower">
        <div class="tip">给学生们鼓励一下吧~</div>
      </button>
      <div class="txt">送花</div>
    </div>
    <div class="rm-menu-item">
      <button class="btn btn-hands  btn-tip btn-tip-left" @click="startHandle">
        <div class="tip">给学生们鼓励一下吧~</div>
      </button>
      <div class="txt">鼓掌</div>
    </div>
    <div class="rm-menu-item rm-font" :class="showSize && 'on'" v-if="showSign">
      <button class="btn btn-font  btn-tip btn-tip-left" @click.stop="showSize = !showSize"></button>
      <div class="txt">课文字号</div>
      <div class="sizes">
        <ul class="flex">
          <li v-for="(size, key) in fontSizes" :key="size" :class="size == (getKnowledgeSettings.size || 1) && 'on'"
            @click="changeSetting('size', size)">
            <span class="spot"></span>
            <span class="stxt">{{ key }}</span>
          </li>
        </ul>
      </div>
    </div>
    <AudioManager ref="flowerAudio" :options="optionsFlower" />
    <AudioManager ref="handleAudio" :options="optionsHandle" />
    <div class="layer flower-layer" v-show="states.isShowFlower">
      <img src="~images/flower.gif" />
    </div>
    <div class="layer handle-layer" v-show="states.isShowHandle">
      <img src="~images/hand.gif" />
    </div>
  </div>
</template>
<script>
import AudioManager from 'business/AudioManager';
import { mapGetters } from "vuex";
import { Switch } from "element-ui";

export default {
  props: {
    showSign: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  components: {
    'el-switch': Switch,
    AudioManager
  },
  data() {
    return {
      optionsFlower: {},
      optionsHandle: {},
      states: {
        isShowFlower: 0,
        isShowHandle: 0
      },
      fontSizes: {
        '特大': 1.8,
        '大': 1.5,
        '默认': 1,
        '小': 0.8,
      },
      showSize: false
    }
  },
  created() {
    this.init();
    this.$store.commit("setKnowledgeSettings", JSON.parse(sessionStorage.getItem('knowSettings') || '{}'))
  },
  computed: {
    ...mapGetters(["getKnowledgeSettings","getKnowledgeSigns"]),
  },
  methods: {
    init() {
      this.optionsFlower = {
        src: require('assets/flower.mp3'),
        onEnded: () => {
          this.states.isShowFlower = 0;
        }
      }
      this.optionsHandle = {
        src: require('assets/hande.wav'),
        onEnded: () => {
          this.states.isShowHandle = 0;
        }
      }
    },
    startFlower() {
      this.states.isShowHandle = 0;
      this.states.isShowFlower = 1;
      this.$refs.handleAudio && this.$refs.handleAudio.stop();
      this.$refs.flowerAudio && this.$refs.flowerAudio.stop();
      this.$refs.flowerAudio && this.$refs.flowerAudio.toggle();
    },
    startHandle() {
      this.states.isShowHandle = 1;
      this.states.isShowFlower = 0;
      this.$refs.flowerAudio && this.$refs.flowerAudio.stop();
      this.$refs.handleAudio && this.$refs.handleAudio.stop();
      this.$refs.handleAudio && this.$refs.handleAudio.toggle();
    },
    changeSetting(key, val) {
      this.$store.commit("setKnowledgeSettings", {
        ...this.getKnowledgeSettings,
        [key]: val,
      });
    }
  }
}
</script>
<style lang="less" scoped>
@import '~styles/mixin';
@import '~styles/var';

.layer {
  position: fixed;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.rm-menu {
  text-align: center;
  position: fixed;
  right: 24px;
  bottom: 140px;
  width: 100px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 1px rgba(189, 94, 39, 0.05);
  border-radius: 8px;
  z-index: 2;
  padding-top: 32px;
  padding-bottom: 16px;
  box-sizing: border-box;

  &::before {
    content: '';
    .bg-url('~images/icon-tool-bg.png');
    width: 92px;
    height: 25px;
    position: absolute;
    top: -5px;
    left: 4px;
  }

  .rm-menu-item {
    font-size: 12px;
    color: #7B3A0A;
    width: 80px;
    height: 80px;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding-top: 8px;

    &.first {
      margin-bottom: 16px;
    }

    .btn {
      display: block;
      margin: 0 auto 5px;
      height: 40px;
      width: 41px;
    }

    .btn-flower {
      .bg-url('~images/btn-flower.png');
    }

    .btn-hands {
      .bg-url('~images/btn-hands.png');
    }

    .btn-font {
      .bg-url('~images/btn-font.png');
    }

    .txt {
      margin: 5px auto 0;
    }

    .sizes {
      width: 220px;
      height: 60px;
      background: #FFFCF7;
      box-shadow: 0px 3px 10px 1px rgba(189, 94, 39, 0.1);
      border-radius: 8px 0px 0px 8px;
      position: absolute;
      // left: -228px;
      left: -218px;
      top: 14px;
      box-sizing: border-box;
      padding: 15px 20px 5px;
      display: none;

      &:after {
        content: '';
        width: 12px;
        height: 86px;
        position: absolute;
        right: 0px;
        top: -16px;
        display: inline-block;
        background: #FFFFFF;
      }

      ul {
        justify-content: space-between;
        height: 100%;
        border-top: 4px solid rgba(251, 124, 51, .1);
        border-radius: 2px;
        cursor: pointer;
      }

      li {
        font-size: 12px;
        color: #666666;
        position: relative;
        padding: 23px 12px 0;
        margin-top: -4px;

        .spot {
          width: 4px;
          height: 4px;
          background: #DA9C75;
          border-radius: 50%;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }

        &.on {
          font-size: 12px;
          color: #FB7C33;
          font-weight: bold;

          .spot {
            width: 14px;
            height: 14px;
            background: #FB7C33;
            top: -5px;
          }
        }
      }
    }

    &.rm-font:hover {
      background: #FFF4D1;

      .sizes {
        display: block;
      }
    }
  }
}
</style>